export const SHOW_PARAMS = [ "cost", "revenue", "onwRevenue", "totalRevenue", "roi", "onwRoi", "factor" ];


// WEBPACK FOOTER //
// ./src/scenes/PushapiFactor/config.js